import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { Event } from './entities';
import { EventsEnvironment } from './environment';

export class EventsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(EventsEnvironment).url, session);
  }

  getEvent = (postId: number): SafePromise<Event> => {
    const url = this.URL(`events/wp-json/wp/v2/event_list/${postId}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getEvents = (): SafePromise<Event[]> => {
    const url = this.URL(`events/wp-json/wp/v2/event_list`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
